import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clearFormBeforeAdd(event) {
    // Find the scoring_rule_form turbo frame and clear it
    // This ensures a clean slate when adding a new rule
    const turboFrame = document.querySelector('turbo-frame[id="scoring_rule_form"]')
    if (turboFrame && turboFrame.innerHTML.trim() !== '') {
      turboFrame.innerHTML = ''
    }
    
    // Let the normal turbo frame navigation proceed
  }
}